export type popupElement = {
  id: string;
  content: string;
}

class SidePopup {
  
  private popup: HTMLElement | null = document.querySelector('.side-popup');
  private popupBg: HTMLElement | null = null;
  private popupContent: HTMLElement | null = null;
  private popupControls: {
    prev: HTMLElement | null,
    next: HTMLElement | null,
    close: HTMLElement | null,
    bottomPrev: HTMLElement | null,
    bottomNext: HTMLElement | null,
  } | null = null;
  private renameBottomControls: string[] = []

  constructor(renameBottomControls: string[] = []) {
    if (!this.popup) return;

    this.popupBg = this.popup.querySelector('.side-popup__bg');
    this.popupContent = this.popup.querySelector('.side-popup__content');
    this.popupControls = {
      prev: this.popup.querySelector('.side-popup__prev'),
      next: this.popup.querySelector('.side-popup__next'),
      close: this.popup.querySelector('.side-popup__close'),
      bottomPrev: this.popup.querySelector('.side-popup__bottom-prev'),
      bottomNext: this.popup.querySelector('.side-popup__bottom-next'),
    };
    this.renameBottomControls = renameBottomControls;

    this.renameBottomControlsFn();

    this.initBaseControls();
  }

  public fillContent(content: string) {
    if (!this.popupContent) return;
    this.popupContent.innerHTML = content.trim();
  }

  public showPopup() {
    if (!this.popup) return;
    this.popup.classList.add('side-popup--active');
    document.documentElement.style.overflowY = 'hidden';
  }

  public hidePopup() {
    if (!this.popup) return;
    this.popup.classList.remove('side-popup--active');
    document.documentElement.style.overflowY = 'auto';
    this.fillContent('');
  }

  private initBaseControls() {
    if (!this.popupControls) return;

    this.popupControls.close?.addEventListener('click', () => {
      this.hidePopup();
    });
    this.popupBg?.addEventListener('click', () => {
      this.hidePopup();
    }); 
  }

  private scrollToTop() {
    this.popup?.querySelector('.side-popup__window')?.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }

  private renameBottomControlsFn() {
    if (!this.popupControls || this.renameBottomControls.length === 0 || !this.popupControls.bottomPrev || !this.popupControls.bottomNext) return;

    this.popupControls.bottomPrev.textContent = this.renameBottomControls[0];
    this.popupControls.bottomNext.textContent = this.renameBottomControls[1];
  }

  public initCustomControls(showPrev: () => void, showNext: () => void) {
    if (!this.popupControls) return;
    this.popupControls.prev?.addEventListener('click', ()=>{
      showPrev();
    });
    this.popupControls.next?.addEventListener('click', ()=>{
      showNext();
    });
    this.popupControls.bottomPrev?.addEventListener('click', ()=>{
      showPrev();
      this.scrollToTop();
    });
    this.popupControls.bottomNext?.addEventListener('click', ()=>{
      showNext();
      this.scrollToTop();
    });
  }


  init() {
  }
}

export default SidePopup;